import React from 'react';

import LogoOntregel from '../Logos/LogoOntregel';
import LogoVVAA from '../Logos/LogoVVAA';
import LogoHRMO from '../Logos/LogoHRMO';
import LogoFabriek from '../Logos/LogoFabriek';

import './Footer.css'

const Footer = (props) => {

	return (
		<div className="Footer ">
			<div className="container">
				<div className="row no-gutters">
					<div className="col-md-8">
						<a href="https://www.vvaa.nl/"><LogoVVAA /></a>
						<a href="https://www.vvaa.nl/landingspagina/ont-regel-de-zorg"><LogoOntregel /></a>
						<a href="http://www.hetroermoetom.nu/"><LogoHRMO /></a>
					</div>
					<div className="col-md-4">
						<div className="credit">
							Gemaakt door:
							<a href="https://www.argumentenfabriek.nl/"><LogoFabriek /></a>
						</div>
					</div>
				</div>
			</div>
		</div>
		)

}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js